/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SpDataByProductFragment = { __typename?: 'SProductsQuery' } & {
  listByProduct: Types.Maybe<
    { __typename?: 'SProductList' } & {
      products: Array<
        { __typename?: 'SProduct' } & Pick<
          Types.SProduct,
          'adPayer' | 'adTrackingData' | 'mgr'
        > & {
            channelOffer: Types.Maybe<
              { __typename?: 'ChannelOffer' } & Pick<
                Types.ChannelOffer,
                'productId'
              > & {
                  sku: { __typename?: 'ChannelOfferSku' } & Pick<
                    Types.ChannelOfferSku,
                    'modelId'
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type SpDataGoogleShoppingPageTopQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  product: Types.SProductListByProduct;
  filters?: Types.InputMaybe<Types.SProductFilters>;
}>;

export type SpDataGoogleShoppingPageTopQuery = { __typename?: 'Query' } & {
  sProducts: Types.Maybe<
    { __typename?: 'SProductsQuery' } & {
      listByProduct: Types.Maybe<
        { __typename?: 'SProductList' } & {
          products: Array<
            { __typename?: 'SProduct' } & Pick<
              Types.SProduct,
              'adPayer' | 'adTrackingData' | 'mgr'
            > & {
                channelOffer: Types.Maybe<
                  { __typename?: 'ChannelOffer' } & Pick<
                    Types.ChannelOffer,
                    'productId'
                  > & {
                      sku: { __typename?: 'ChannelOfferSku' } & Pick<
                        Types.ChannelOfferSku,
                        'modelId'
                      >;
                    }
                >;
              }
          >;
        }
      >;
    }
  >;
};

export type SpDataProductPageTopQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  product: Types.SProductListByProduct;
  filters?: Types.InputMaybe<Types.SProductFilters>;
}>;

export type SpDataProductPageTopQuery = { __typename?: 'Query' } & {
  sProducts: Types.Maybe<
    { __typename?: 'SProductsQuery' } & {
      listByProduct: Types.Maybe<
        { __typename?: 'SProductList' } & {
          products: Array<
            { __typename?: 'SProduct' } & Pick<
              Types.SProduct,
              'adPayer' | 'adTrackingData' | 'mgr'
            > & {
                channelOffer: Types.Maybe<
                  { __typename?: 'ChannelOffer' } & Pick<
                    Types.ChannelOffer,
                    'productId'
                  > & {
                      sku: { __typename?: 'ChannelOfferSku' } & Pick<
                        Types.ChannelOfferSku,
                        'modelId'
                      >;
                    }
                >;
              }
          >;
        }
      >;
    }
  >;
};

export type SpDataProductPageQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  product: Types.SProductListByProduct;
  filters?: Types.InputMaybe<Types.SProductFilters>;
}>;

export type SpDataProductPageQuery = { __typename?: 'Query' } & {
  sProducts: Types.Maybe<
    { __typename?: 'SProductsQuery' } & {
      listByProduct: Types.Maybe<
        { __typename?: 'SProductList' } & {
          products: Array<
            { __typename?: 'SProduct' } & Pick<
              Types.SProduct,
              'adPayer' | 'adTrackingData' | 'mgr'
            > & {
                channelOffer: Types.Maybe<
                  { __typename?: 'ChannelOffer' } & Pick<
                    Types.ChannelOffer,
                    'productId'
                  > & {
                      sku: { __typename?: 'ChannelOfferSku' } & Pick<
                        Types.ChannelOfferSku,
                        'modelId'
                      >;
                    }
                >;
              }
          >;
        }
      >;
    }
  >;
};

export type SpDataProductPageHighlightQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  product: Types.SProductListByProduct;
  filters?: Types.InputMaybe<Types.SProductFilters>;
}>;

export type SpDataProductPageHighlightQuery = { __typename?: 'Query' } & {
  sProducts: Types.Maybe<
    { __typename?: 'SProductsQuery' } & {
      listByProduct: Types.Maybe<
        { __typename?: 'SProductList' } & {
          products: Array<
            { __typename?: 'SProduct' } & Pick<
              Types.SProduct,
              'adPayer' | 'adTrackingData' | 'mgr'
            > & {
                channelOffer: Types.Maybe<
                  { __typename?: 'ChannelOffer' } & Pick<
                    Types.ChannelOffer,
                    'productId'
                  > & {
                      sku: { __typename?: 'ChannelOfferSku' } & Pick<
                        Types.ChannelOfferSku,
                        'modelId'
                      >;
                    }
                >;
              }
          >;
        }
      >;
    }
  >;
};

export const SpDataByProductFragmentDoc = /*#__PURE__*/ `
    fragment SpDataByProduct on SProductsQuery {
  listByProduct(context: $context, product: $product, filters: $filters) {
    products {
      adPayer
      adTrackingData
      mgr
      channelOffer {
        productId
        sku {
          modelId
        }
      }
    }
  }
}
    `;
export const SpDataGoogleShoppingPageTopDocument = /*#__PURE__*/ `
    query SpDataGoogleShoppingPageTop($context: SContentContext!, $product: SProductListByProduct!, $filters: SProductFilters) {
  sProducts {
    ...SpDataByProduct
  }
}
    ${SpDataByProductFragmentDoc}`;

export function useSpDataGoogleShoppingPageTopQuery(
  options: Omit<
    Urql.UseQueryArgs<SpDataGoogleShoppingPageTopQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SpDataGoogleShoppingPageTopQuery,
    SpDataGoogleShoppingPageTopQueryVariables
  >({ query: SpDataGoogleShoppingPageTopDocument, ...options });
}
export const SpDataProductPageTopDocument = /*#__PURE__*/ `
    query SpDataProductPageTop($context: SContentContext!, $product: SProductListByProduct!, $filters: SProductFilters) {
  sProducts {
    ...SpDataByProduct
  }
}
    ${SpDataByProductFragmentDoc}`;

export function useSpDataProductPageTopQuery(
  options: Omit<Urql.UseQueryArgs<SpDataProductPageTopQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    SpDataProductPageTopQuery,
    SpDataProductPageTopQueryVariables
  >({ query: SpDataProductPageTopDocument, ...options });
}
export const SpDataProductPageDocument = /*#__PURE__*/ `
    query SpDataProductPage($context: SContentContext!, $product: SProductListByProduct!, $filters: SProductFilters) {
  sProducts {
    ...SpDataByProduct
  }
}
    ${SpDataByProductFragmentDoc}`;

export function useSpDataProductPageQuery(
  options: Omit<Urql.UseQueryArgs<SpDataProductPageQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SpDataProductPageQuery, SpDataProductPageQueryVariables>(
    { query: SpDataProductPageDocument, ...options },
  );
}
export const SpDataProductPageHighlightDocument = /*#__PURE__*/ `
    query SpDataProductPageHighlight($context: SContentContext!, $product: SProductListByProduct!, $filters: SProductFilters) {
  sProducts {
    ...SpDataByProduct
  }
}
    ${SpDataByProductFragmentDoc}`;

export function useSpDataProductPageHighlightQuery(
  options: Omit<
    Urql.UseQueryArgs<SpDataProductPageHighlightQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SpDataProductPageHighlightQuery,
    SpDataProductPageHighlightQueryVariables
  >({ query: SpDataProductPageHighlightDocument, ...options });
}
